import React, { useCallback } from 'react';
import { getAgent, listAgents } from '../../api/agents';
import { getAgentAdmin, listAgentsAdmin } from '../../api/agentsAdmin';
import AsyncSearchSelect from '../ui/AsyncSearchSelect';

function formatAgentLabel(agent) {
  if (agent.account?.name) {
    return `${agent.name} (${agent.account.name})`;
  }
  return agent.name;
}

function AgentSearchSelect({
  id = 'agent-search',
  value,
  onChange,
  mode = 'user',
  showAllOption = mode === 'admin',
  layout = 'inline',
  label = 'Agente',
  disabled = false,
  placeholder = 'Buscar agente...',
  emptyLabel,
}) {
  const resolvedEmptyLabel =
    emptyLabel || (showAllOption ? 'Todos os agentes' : 'Selecione um agente');

  const loadOptions = useCallback(
    async (search) => {
      const response =
        mode === 'admin'
          ? await listAgentsAdmin({ page: 1, perPage: 20, search: search || undefined })
          : await listAgents({ page: 1, perPage: 20, search: search || undefined });

      return (response.data || []).map((agent) => ({
        value: agent.id,
        label: mode === 'admin' ? formatAgentLabel(agent) : agent.name,
      }));
    },
    [mode]
  );

  const resolveOption = useCallback(
    async (agentId) => {
      const agent =
        mode === 'admin' ? await getAgentAdmin(agentId) : await getAgent(agentId);
      return {
        value: agent.id,
        label: mode === 'admin' ? formatAgentLabel(agent) : agent.name,
      };
    },
    [mode]
  );

  return (
    <AsyncSearchSelect
      id={id}
      label={label}
      value={value}
      onChange={onChange}
      loadOptions={loadOptions}
      resolveOption={resolveOption}
      allowEmpty={showAllOption}
      emptyLabel={resolvedEmptyLabel}
      disabled={disabled}
      placeholder={placeholder}
      layout={layout}
      inputClassName={
        layout === 'inline'
          ? 'rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-content-primary min-w-0 w-full'
          : 'field-input w-full'
      }
    />
  );
}

export default AgentSearchSelect;
